export default __webpack_public_path__ + "static/media/Corsairs-treasure-06.bf636e6c.png";